import {connect} from 'react-redux';
import {TimespanCategory} from '@pluto/rest';
import {TimespanCategoriesState} from '@pluto/timespan-categories';
import {TimelineState} from 'VideoAudioQC/Timeline/Redux/TimelineReducer';
import {
    RemoveMarkupMarkerAction,
    removeMarkupMarkerAction,
    UpdateMarkupMarkerAction,
    updateMarkupMarkerAction,
} from 'VideoAudioQC/Timeline/Markup/Redux/MarkupActions';
import {MarkupState} from 'VideoAudioQC/Timeline/Markup/Redux/MarkupReducer';
import {MarkupMarker} from 'VideoAudioQC/Timeline/TimelineTypes';
import {toggleSelectedMarkerAction} from '../../Timeline/Redux/TimelineActions';
import MarkupContainer from './MarkupContainer';

interface TimelineStore {
    markup: MarkupState;
    selectedMarker: TimelineState;
}

export interface State {
    timeline: TimelineStore;
    qcTools: {
        timespanCategories: TimespanCategoriesState;
    },
}

interface StateProps {
    identifier: string;
    markers: MarkupMarker[];
    selectedRowId: string;
    selectedMarkerId: string;
    noteTypes: TimespanCategory[];
}

export const mapState = (state: State): StateProps => {
    const {
        timeline,
        qcTools,
    } = state;
    const {
        selectedMarker,
        markup,
    } = timeline;
    const {timespanCategories} = qcTools;
    const {
        markers,
        rowId,
    } = markup;
    const {
        selectedRowId,
        selectedMarkerId,
    } = selectedMarker;
    const noteTypes = timespanCategories.markup;
    
    return {
        identifier: rowId,
        markers,
        selectedRowId,
        selectedMarkerId,
        noteTypes,
    };
};

export const mapDispatch = {
    toggleSelectedMarker: toggleSelectedMarkerAction,
    removeMarkupMarker: removeMarkupMarkerAction as RemoveMarkupMarkerAction,
    updateMarkupMarker: updateMarkupMarkerAction as UpdateMarkupMarkerAction,
};

export default connect(mapState, mapDispatch)(MarkupContainer);
